<template>
    <scroll-pull-down onScrollTop="50px" onScrollBackgroundColor="#FFF">
        <div slot="header">
            <scroll-header-menu onMenuHeight="50px" :onBeBackState="BeBackStateEcho" :onBeBackAuto="false" onBeBackNoticeState="2" @onBeBackNotice="onBeBackNotice" onTitle="注册 OR 登录"></scroll-header-menu>
        </div>
        <div class="app-screen" slot="container">
            <transition enter-active-class="view-main animated adding fadeIn" leave-active-class="view-main animated adding fadeOut" keep-alive mode="out-in">
                <!-- 步奏1: 输入手机号码 -->
                <div class="app-screen-container" v-if="options.step === 1" :key="1">
                    <div class="step-enroll">
                        <div class="identifier">+86</div>
                        <input type="text" v-model="database.mobile" placeholder="请输入手机号码">
                    </div>
                    <div class="step-notes">手机号码将会作为会员登录凭证!</div>
                    <div class="step-container">
                        <div class="step-button" :class="isRightMobile && 'active'" @click="onChangeStep(1)">下一步</div>
                    </div>
                </div>
                <!-- 步奏2: 短信验校码登录 OR 注册, 发送并输入短信验校码 -->
                <div class="app-screen-container" v-else-if="options.step === 2" :key="2">
                    <div class="step-enroll">
                        <input type="text" class="code" v-model="database.code" placeholder="请输入验校码">
                    </div>
                    <div class="step-notes">请留意您的手机短信息<br>如果您长时间没有收到信息, 可以尝试重新发送</div>
                    <div class="step-tools" v-if="options.existPassword">
                        <span class="pull-left text-primary" @click="onSetStep(3)">密码登录</span>
                        <span></span>
                    </div>
                    <div class="step-container">
                        <div class="step-button active" v-if="isCodeLength" @click="onChangeStep(1)">下一步</div>
                        <div class="step-button" v-else-if="options.timing > 0">{{options.timing}}S</div>
                        <div class="step-button active" v-else-if="!isCodeLength" @click="onSendMobileCode">获取验校码</div>
                    </div>
                </div>
                <!-- 步奏2: 密码登录 -->
                <div class="app-screen-container" v-else-if="options.step === 3" :key="3">
                    <div class="step-enroll">
                        <input type="password" class="password" v-model="database.password" placeholder="请输入密码">
                    </div>
                    <div class="step-tools">
                        <span class="pull-left text-primary" @click="onSetStep(2)">短信验证登录</span>
                        <span class="pull-right text-danger" @click="onSetStep(5)">忘记密码?</span>
                    </div>
                    <div class="step-container">
                        <div class="step-button" v-if="!isPasswordLength">下一步</div>
                        <div class="step-button active" v-else @click="onSelfEnroll()">下一步</div>
                    </div>
                </div>
                <!-- 步奏3: 用户已存在, 但未设置密码, 设置用户密码 -->
                <div class="app-screen-container" v-else-if="options.step === 4" :key="4">
                    <div class="step-enroll">
                        <input type="password" class="password" v-model="database.password" placeholder="请输入新密码">
                    </div>
                    <div class="step-enroll">
                        <input type="password" class="password" v-model="database.confirm_password" placeholder="再次确认新密码">
                    </div>
                    <div class="step-container">
                        <div class="step-button ignore" @click="onSelfEnroll(false)">忽略密码设置</div>
                        <div class="step-button active" @click="onSelfEnroll()">下一步</div>
                    </div>
                </div>
                <!-- 步奏3: 用户忘记密码, 重新验证密码 -->
                <div class="app-screen-container" v-else-if="options.step === 5" :key="5">
                    <div class="step-enroll">
                        <input type="text" class="code" v-model="database.code" placeholder="请输入验校码">
                    </div>
                    <div class="step-notes">请留意您的手机短信息<br>如果您长时间没有收到信息, 可以尝试重新发送</div>
                    <div class="step-tools" v-if="options.existPassword">
                        <span class="pull-left text-primary" @click="onSetStep(3)">密码登录</span>
                    </div>
                    <div class="step-container">
                        <div class="step-button active" v-if="isCodeLength" @click="onSetStep(6)">下一步</div>
                        <div class="step-button" v-else-if="options.timing > 0">{{options.timing}}S</div>
                        <div class="step-button active" v-else-if="!isCodeLength" @click="onSendMobileCode">获取验校码</div>
                    </div>
                </div>
                <!-- 步奏4: 设置新的密码 -->
                <div class="app-screen-container" v-else-if="options.step === 6" :key="6">
                    <div class="step-enroll">
                        <input type="password" class="password" v-model="database.password" placeholder="请输入新密码">
                    </div>
                    <div class="step-enroll">
                        <input type="password" class="password" v-model="database.confirm_password" placeholder="再次确认新密码">
                    </div>
                    <div class="step-container">
                        <div class="step-button active" @click="onResetPassword()">下一步</div>
                    </div>
                </div>
            </transition>
        </div>
    </scroll-pull-down>
</template>
<script>
    import ScrollPullDown from '@/public/ScrollPullDown'
    import ScrollHeaderMenu from '@/public/ScrollHeaderMenu'
    import Core from '@/until/core'
    export default {
        name: 'MobileEnroll',
        data () {
            return {
                options: {
                    step: 1,
                    beBack: true,
                    mobileExist: false,
                    existPassword: false,
                    timing: 0
                },
                database: {
                    mobile: '',
                    code: '',
                    password: '',
                    confirm_password: ''
                }
            }
        },
        components: {
            ScrollPullDown,
            ScrollHeaderMenu
        },
        watch: {},
        computed: {
            BeBackStateEcho () {
                return this.options.step > 1 && this.options.beBack ? '上一步' : ''
            },
            isRightMobile () {
                return /^1(3|4|5|7|8|9)\d{9}$/.test(this.database.mobile)
            },
            isCodeLength () {
                return String(this.database.code || '').length >= 5
            },
            isPasswordLength () {
                return String(this.database.password || '').length >= 6
            }
        },
        filters: {},
        methods: {
            onHeader () {
            },
            onBeBackNotice () {
                const that = this
                if (that.options.step > 1 && !that.options.beBack) {
                    that.onSetStep(that.options.step - 1)
                } else if (that.options.beBack > 0) {
                    that.options.step = parseInt(that.options.beBack, 10) || 1
                    that.options.beBack = 0
                }
            },
            onSetStep (index) {
                const that = this
                that.options.step = index
                if (that.options.step === 2 && that.isRightMobile) {
                    that.database.code = ''
                    that.options.beBack = 1
                } else if (that.options.step === 3 && that.isRightMobile) {
                    that.database.password = ''
                    that.options.beBack = 1
                }
            },
            onChangeStep (index) {
                const that = this
                if (that.options.step === 1 && that.isRightMobile) {
                    that.$store.commit('onChangeAppLoaderShow', true)
                    Core('Api/Member/QueryMobileExist', { mobile: that.database.mobile, user_id: parseInt(that.$route.params.Uid, 10) || 0 }).then(body => {
                        that.options.mobileExist = false
                        that.options.existPassword = false
                        that.$store.commit('onChangeAppLoaderShow', false)
                        if (!body.data || body.data.error_code) {
                            return that.$store.commit('onChangeAppMessage', body.data.error_msg)
                        } else if (body.data.data === 'exist_password') {
                            that.options.mobileExist = true
                            that.options.existPassword = true
                            that.onSetStep(3) // 输入密码
                            return null
                        } else if (parseInt(body.data.data, 10) > 0) {
                            that.options.mobileExist = true
                            that.onSetStep(2) // 短信息验证登录
                            return null
                        }
                        that.onSetStep(2) // 短信息验证
                    })
                } else if (that.options.step === 2) {
                    if (that.options.existPassword) {
                        that.onSelfEnroll()
                    } else {
                        that.options.beBack = 2
                        that.options.step = 4
                    }
                }
            },
            onSendMobileCode () {
                const that = this
                const param = {
                    user_id: parseInt(that.$route.params.Uid, 10) || 0,
                    mobile: that.database.mobile
                }
                if (that.isCodeLength) {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    return null
                }
                if (that.options.timing > 0) {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    return that.$store.commit('onChangeAppMessage', '请稍候再试')
                }
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('Api/Member/SendEnrollValidate', param).then(body => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data.error_code && parseInt(body.data.data, 10) === parseInt(param.mobile, 10)) {
                        that.options.timing = 60
                        let timingIndex = null
                        const timingCall = () => {
                            if (that.options.timing <= 0) {
                                timingIndex && clearTimeout(timingIndex)
                                return null
                            }
                            that.options.timing -= 1
                            setTimeout(timingCall, 1000)
                        }
                        return timingCall()
                    }
                    that.$store.commit('onChangeAppMessage', body.data.error_msg)
                })
            },
            onSelfEnroll (ignorePassword) {
                const that = this
                const param = Object.assign({}, {share_id: that.$route.params.ShareId || '', user_id: parseInt(that.$route.params.Uid, 10) || 0}, that.database)
                if (ignorePassword === false) {
                    param.password = ''
                    param.confirm_password = ''
                }
                if (param.confirm_password && param.confirm_password !== param.password) {
                    return that.$store.commit('onChangeAppMessage', '两次密码必须一致, 请验校后再试')
                }
                that.$store.commit('onChangeAppLoaderShow', '正在提交, 请稍候...')
                Core('Api/Member/SelfEnroll', param).then(body => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data || body.data.error_code) {
                        return that.$store.commit('onChangeAppMessage', body.data.error_msg)
                    }
                    that.options.beBack = 0
                    const router = Core.loginWrite(body.data.data)
                    if (router && router.route.query.source) {
                        // 跳转到登录 OR 注册前的界面中
                        return that.$router.push({path: router.route.query.source})
                    } else if (router) {
                        return that.$router.push({name: 'StaffCenter', params: that.$route.params, query: that.$route.query})
                    }
                    return that.$store.commit('onChangeAppMessage', '登录失败, 请稍候再试')
                })
            },
            onResetPassword () {
                const that = this
                const param = Object.assign({}, {user_id: parseInt(that.$route.params.Uid, 10) || 0}, that.database)
                that.options.beBack = 0
                that.$store.commit('onChangeAppLoaderShow', '正在提交, 请稍候...')
                Core('Api/Member/ResetPassword', param).then(body => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data || body.data.error_code) {
                        return that.$store.commit('onChangeAppMessage', body.data.error_msg)
                    }
                    const router = Core.loginWrite(body.data.data)
                    if (router) {
                        that.$store.commit('onChangeAppMessage', '密码重置成功并登录中...')
                        setTimeout(() => {
                            // 跳转到登录 OR 注册前的界面中
                            that.$router.push({path: router.route.query.source})
                            that.options.beBack = 1
                        }, 3000)
                        return null
                    }
                    return that.$store.commit('onChangeAppMessage', '密码重置失败, 请稍候再试')
                })
            }
        },
        created () {
            Core.stopHistory(this.$route.fullPath, true)
        },
        mounted () {
            const that = this
            if (Core.loginExist()) {
                that.$router.push({name: 'PersonalCenter', params: that.$route.params, query: that.$route.query})
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
.app-screen { position: relative; width: 100%; height: 100%; perspective: 1200px; transform-style: preserve-3d; background-color: #FFF; }
.app-screen-main { transform: translate3d(0, 0, 0); }
.app-screen-container{ padding-top: 30px; padding-right: 10px; padding-left: 10px; position: relative; }
.app-screen-container .step-enroll{ position: relative; font-size: 16px; border-bottom: 1px solid #EBEBEB; padding-bottom: 15px; padding-top: 12px; }
.app-screen-container .step-enroll .identifier{ position: absolute; top: 12px; left: 0; width: 50px; height: 25px; line-height: 25px; color: #CCC; text-align: center; }
.app-screen-container .step-enroll .code{ padding-left: 0; text-align: center; }
.app-screen-container .step-enroll .password{ padding-right: 10px; padding-left: 10px;}
.app-screen-container .step-enroll input{ border: 0; background-color: transparent; width: 100%; height: 25px; line-height: 25px; padding-left: 50px; outline: none; }
.app-screen-container .step-notes{ font-size: 12px; text-align: right; color: #B5B6CA; padding-top: 18px; padding-bottom: 18px; font-size: 14px; }
.app-screen-container .step-tools{ margin-top: 20px; text-align: center; height: 22px; line-height: 22px; }
.app-screen-container .step-container{ padding-top: 70px; text-align: center; font-size: 16px; }
.app-screen-container .step-button{ display: block; width: 100%; height: 50px; line-height: 50px; text-align: center; background-color: #CCCCCC; color: #FFF; border-radius: 25px; border: 1px solid transparent; }
.app-screen-container .step-button.active{ border-color: #FF6068; background: linear-gradient(#FE4B4B, #E81B16); }
.app-screen-container .step-button.ignore{ margin-bottom: 8px; background-color: transparent; color: #FF6068; }
</style>



// WEBPACK FOOTER //
// src/components/MobileEnroll.vue